import { useScrollReveal } from 'shared/hooks/useScrollReveal';
import { cn } from 'shared/utils/cn';

export function ConstellationDivider({ className }: { className?: string }) {
  const reveal = useScrollReveal({ animation: 'fade' });

  return (
    <div ref={reveal.ref} style={reveal.style} className={cn('flex items-center gap-8', className)}>
      <div className="w-1.5 h-1.5 rounded-full bg-tertiary-fixed-dim" />
      <div className="w-1.5 h-1.5 rounded-full bg-tertiary-fixed-dim" />
      <div className="w-1.5 h-1.5 rounded-full bg-tertiary-fixed-dim" />
    </div>
  );
}
